import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Reflux from 'reflux';
import { Actions } from './components/Actions';
import * as Common from './components/Common';
// import { messaging } from './init-fcm';
// import firebase from 'firebase';
import './App.css';
import './css/common.css';
import './css/styleDefault.css';
import './css/layout.css';
import './css/main.css';
import './css/content.css';

import Home from './routes/Home';
import Experience from './routes/Experience';
import ExperienceModify from './routes/ExperienceModify';
import Branch from './routes/Branch';
import Introduce from './routes/Introduce';
import Introduce01 from './routes/Introduce01';
import Introduce02 from './routes/Introduce02';
import Introduce03 from './routes/Introduce03';
import Introduce04 from './routes/Introduce04';
import Trial from './routes/Trial';
import Voc from './routes/Voc';
import Yaneodoo from './routes/Yaneodoo';
import Longterm2006 from './routes/Longterm2006';
import Longterm2008 from './routes/Longterm2008';
import Miracle2006 from './routes/Miracle2006';
import Miracle2008 from './routes/Miracle2008';
import Moim2006 from './routes/Moim2006';
import B2b2006 from './routes/B2b2006';
import EventExperience from './routes/EventExperience';
import EventBranch from './routes/EventBranch';
import EventAutumnStudy from './routes/EventAutumnStudy';
import EventConsulting2020 from './routes/EventConsulting2020';
import EventConsulting2106 from './routes/EventConsulting2106';
import EventConsulting2105 from './routes/EventConsulting2105';
import EventConsulting from './routes/EventConsulting';
import EventSurprise2106 from './routes/EventSurprise2106';
import Privacy from './routes/Privacy';
import Policy from './routes/Policy';
// import Report from './routes/Report';

import Loading from './components/Loading';
import CommonAlert from './components/CommonAlert';
import EventCheerup from './routes/EventCheerup';

// const firebaseConfig = {
//   apiKey: "AIzaSyCDRii4xssDWpQ-uxDrGnuhYFgQ8X5u3JY",
//   authDomain: "mstudy-a5a89.firebaseapp.com",
//   databaseURL: "https://mstudy-a5a89.firebaseio.com",
//   projectId: "mstudy-a5a89",
//   storageBucket: "",
//   messagingSenderId: "337543267755",
//   appId: "1:337543267755:web:d1481685ae0ade29"
// };

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isOpenAlert: false,
      alertMsg: '',
      buttonLabel: []
    };

    Reflux.createStore({
      init: function() {
        this.listenTo(Actions.loadingState, this.loadingState);
        this.listenTo(Actions.alertOpen, this.alertOpen);
        this.listenTo(Actions.alertClose, this.alertClose);
        this.listenTo(Actions.doMovePage, this.doMovePage);
        this.listenTo(Actions.goBack, this.goBack);
      },
      loadingState: (isLoading) => {
        this.setState({
          isLoading: isLoading,
        });
      },
      alertOpen: (msgObj, buttonLabel) => {
        this.setState({
          alertMsg: msgObj,
          buttonLabel: buttonLabel,
          isOpenAlert: true,
          isLoading: false,
        });

        // Common.disableScroll();
      },
      alertClose: (obj, e) => {
        this.setState({
          isOpenAlert: false
        });

        if(obj.callback) {
          obj.callback(obj.param ? obj.param : null);
        }

        // Common.enableScroll();
      },
      doMovePage: (param) => {
        window.location.href = param;
      },
      goBack: () => {
        window.history.back();
      }
    });
  }

  componentDidMount() {
    // messaging.requestPermission()
    // .then(async function() {
    //   const token = await messaging.getToken();
    //   console.log(token);
    // })
    // .catch(function(err) {
    //   console.log("Unable to get permission to notify.", err);
    // });
    // navigator.serviceWorker.addEventListener("message", (message) => console.log(message));

    // messaging.onMessage(function(payload){
    //   console.log(payload.notification.title);
    //   console.log(payload.notification.body);

    //   let _notification = payload.notification;
    //   let _title = payload.notification.title;

    //   _notification.image = "https://mstudyalphatoz.toz.one/meat.jpg";
    //   _notification.actions = [
    //     {
    //       action: '찍먹',
    //       title: '찍먹'
    //     },
    //     {
    //       action: '부먹',
    //       title: '부먹'
    //     }
    //   ];

    //   console.log(_notification);

    //   navigator.serviceWorker.ready.then(function(registration) {
    //     registration.showNotification(_title, _notification);
    //   });
    // })    
  }

  render() {
    return (
      <Router>
        <div id="content">
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/branch/:branch_id" component={Branch} />
            <Route path="/experience/modify" component={ExperienceModify} />
            <Route path="/experience/cancel" component={ExperienceModify} />
            <Route path="/experience/request" component={Experience} />
            <Route path="/experience/inquiry" component={Experience} />
            <Route path="/introduce" component={Introduce} />
            <Route path="/introduce01" component={Introduce01} />
            <Route path="/introduce02" component={Introduce02} />
            <Route path="/introduce03" component={Introduce03} />
            <Route path="/introduce04" component={Introduce04} />
            <Route path="/voc/:membership_id?" component={Voc} />
            <Route path="/event/trial" component={Trial} />
            <Route path="/event/yaneodoo" component={Yaneodoo} />
            <Route path="/event/longterm/2006" component={Longterm2006} />
            <Route path="/event/longterm/2008" component={Longterm2008} />
            <Route path="/event/miracle/2006" component={Miracle2006} />
            <Route path="/event/miracle/2008" component={Miracle2008} />
            <Route path="/event/moim_2006" component={Moim2006} />
            <Route path="/event/b2b_2006" component={B2b2006} />
            <Route path="/event/experience" component={EventExperience} />
            <Route path="/event/cheerup" component={EventCheerup} />
            <Route path="/event/autumnstudy" component={EventAutumnStudy} />
            <Route path="/event/consulting" component={EventConsulting} />
            <Route path="/event/consulting_june" component={EventConsulting2106} />
            <Route path="/event/surprise_3" component={EventSurprise2106} />
            <Route path="/event/branch/:branch_event_id" component={EventBranch} />
            <Route path="/rule/privacy" component={Privacy} />
            <Route path={["/rule/policy/:branchType/:taxType", "/rule/policy/:branchType"]} component={Policy} />
            {/* <Route path="/report" component={Report} /> */}
          </Switch>
          {this.state.isLoading ? <Loading /> : ''}
          {this.state.isOpenAlert ? <CommonAlert msgObj={this.state.alertMsg} buttonLabel={this.state.buttonLabel} onClick={Actions.alertClose} /> : ''}
        </div> 
      </Router>
    );
  }
}

export default App;
